/**
 * @file Watermark placement options. Currently only SE (corner) and SC (full bottom banner)
 * are given as options to users.
 *
 */

const WATERMARK_PLACEMENTS = {
  NE: 'NE',
  SE: 'SE',
  SW: 'SW',
  NW: 'NW',
  C: 'C',
  SC: 'SC',
};

export { WATERMARK_PLACEMENTS };
